import React from "react";

export default function InformationRibon(props) {
  return (
    <div className="ribon-information-v2">
      {props.infoLabel}: {props.labelContent}
    </div>
  );
}
